import { DAY_IN_MS, HOUR_IN_MS, MINUTE_IN_MS } from '@fiverr-private/futile';
import { TIME_UNIT } from './constants';

const SECOND_IN_MS = 1000;
const MILLISECOND = 1;

/**
 * Convert time unit string to it's value in milliseconds
 * @param {string} timeUnit
 * @returns {number}
 */
export const timeUnitToMS = (timeUnit) => {
    switch (timeUnit) {
        case TIME_UNIT.DAY:
            return DAY_IN_MS;
        case TIME_UNIT.HOUR:
            return HOUR_IN_MS;
        case TIME_UNIT.MINUTE:
            return MINUTE_IN_MS;
        case TIME_UNIT.SECOND:
            return SECOND_IN_MS;
        case TIME_UNIT.MILLISECOND:
            return MILLISECOND;

        default:
            throw new Error('convertUnitToMS - unrecognized time unit');
    }
};

/**
 * Returns the time passed since the given start time in the given time units, rounded down,
 * @param {number} start start time as unix time in milliseconds
 * @param {string} resultTimeUnit result time unit
 * @returns {number}
 */
export const calculateTimeDifference = (start, resultTimeUnit) => {
    const diffInMS = Math.max(Date.now() - start, 0);

    return Math.floor(diffInMS / timeUnitToMS(resultTimeUnit));
};
